@if (!isLoading()) {
	<aside
		class="navigation navigation-theme--{{ activeTheme() }}"
		[class.navigation--modal-open]="modalService.isAnyModalOpen()"
	>
		@if (breakpoint.isDesktop()) {
			<div class="navigation__permabar">
				<nav class="navigation__permabar__nav">
					<navigation-items
						type="category"
						[items]="data()"
						[nestingLevel]="0"
						[activeTheme]="activeTheme()"
						(onClickItem)="clickMenuItem($event)"
					></navigation-items>
				</nav>

				<div class="navigation__permabar__buttons">
					<dark-mode-toggle variant="naviation"></dark-mode-toggle>
				</div>
			</div>

			<div
				class="navigation__submenu-spacer"
				[class.has-content]="hasExpandedSubmenu()"
			></div>
		}

		@if (breakpoint.isMobile()) {
			<div
				class="navigation__mobile{{ readerVisible ? ' reader-visible' : '' }}{{
					isVisible ? ' is-visible' : ''
				}}"
			>
				<div class="space">
					<button
						htm-button
						theme="icon"
						attr.aria-label="{{ 'button.close' | translate }} {{
							'frontpage.main_menu' | translate
						}}"
						(click)="closeNavigation()"
						#mobileCloser
					>
						<span class="button--label">
							<icon
								class="xmedium"
								glyph="x"
								size="xmedium"
								aria-hidden="true"
							></icon>
						</span>
					</button>
				</div>

				<div class="navigation__mobile__inner">
					<navigation-items
						[items]="data()"
						[nestingLevel]="1"
						type="item"
						[activeTheme]="activeTheme()"
						(onClickItem)="clickMenuItem($event)"
					></navigation-items>
				</div>

				<div class="navigation__mobile-buttons">
					<language-switcher
						[languageData]="languageService.languageSwitcherData$ | async"
						(languageChangeEvent)="languageService.handleLanguageChange($event)"
						[isInSidemenu]="true"
					></language-switcher>

					<dark-mode-toggle variant="mobile"></dark-mode-toggle>
				</div>
			</div>
		}
	</aside>
}
